import React from 'react'
import create from 'zustand'
import { pick } from 'lodash-es'
import { showNotification } from '@mantine/notifications'
import { useTbViewStore } from '@vt/hooks'
import useTbDataEdit from './use-edit'
import useInlineEdit from './inline/use-edit'
import useshowLog from '../popup-log/use-log-modal'
import { showDetail } from '../details-copy'
import { DataOperateProvider } from './data-operate-store-provider'

export default function ({ children, ...rest }) {
  const { title, appendTbData, updateTbData } = useTbViewStore((state) =>
    pick(state, ['appendTbData', 'updateTbData', 'title'])
  )

  const {
    open: showCreate,
    DittoFormModalRender,
    close: onCloseCreateModal,
  } = useTbDataEdit({
    onSubmit: (subedVal, { extProps }, afterCommitFn) => {
      if (subedVal.objectId) {
        updateTbData(subedVal, extProps)
          .then(() => {
            showNotification({
              title: '操作成功',
            })

            onCloseCreateModal()
            showDetail({
              currentData: { objectId: subedVal.objectId },
              showCreate,
            })
          })
          .finally(() => {
            if (afterCommitFn && typeof afterCommitFn === 'function') {
              afterCommitFn()
            }
          })
      } else {
        appendTbData(subedVal)
          .then(() => {
            showNotification({
              title: '操作成功',
            })
            onCloseCreateModal()
            showDetail({ currentData: { objectId: subedVal.objectId } })
          })
          .finally(() => {
            if (afterCommitFn && typeof afterCommitFn === 'function') {
              afterCommitFn()
            }
          })
      }
    },
    title,
  })

  const {
    open: showTbInlineEdit,
    DittoInlineModalRender,
    close: onCloseInlineModal,
  } = useInlineEdit({
    onSubmit: (subedVal) => {
      updateTbData(subedVal).then(() => {
        showNotification({
          title: '操作成功',
        })
        onCloseInlineModal()
      })
    },
  })

  const { open: showLog, LogModalRender } = useshowLog()

  const createStore = create(() => ({
    operators: {
      showCreate,
      showTbInlineEdit,
      showLog,
      showTbDetail: showDetail,
    },
    ...rest,
  }))

  return (
    <DataOperateProvider createStore={createStore}>
      {children}
      {DittoFormModalRender}
      {DittoInlineModalRender}
      {LogModalRender}
    </DataOperateProvider>
  )
}
